import script from "./ScheduleReminderItem.vue?vue&type=script&setup=true&lang=js"
export * from "./ScheduleReminderItem.vue?vue&type=script&setup=true&lang=js"

import "./ScheduleReminderItem.vue?vue&type=style&index=0&id=2431a0be&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2431a0be"]])

export default __exports__